export const resetPasswordPageText = {
    firstExplainText: '가입하신 이메일 아이디를 입력하시면,',
    secondExplainText: '해당 이메일로 비밀번호 재설정 링크를 전달해드립니다.',
};
